/**
 * Tab 标签页面
 */
import Vue from 'vue'
import ElTabsTabs from './src/main'

ElTabsTabs.install = () => {
  Vue.component(ElTabsTabs.name, ElTabsTabs)
}

export default ElTabsTabs
